import { useRouter } from 'next/router';
import { updateUrlWithParam } from '@doda/common/src/utils/urlUtil';
import { JOB_COUNT_PER_PAGE } from 'constants/jobList';

interface UsePagerArgs {
  /** 全体の件数。 */
  totalCount?: number;
  /** 現在のページ番号。 */
  currentPage: number;
}

/**
 * ページネーションのフック
 *
 * @param {UsePagerArgs} args - ページネーションの引数
 * @param {number} args.totalCount - 全体の件数
 * @param {number} args.currentPage - 現在のページ番号
 * @returns {{maxPage: number, currentPage: number, createPageHref: (page: number) => string}} ページネーション関連のデータと関数
 */
export const usePager = ({ totalCount, currentPage }: UsePagerArgs) => {
  const router = useRouter();
  const maxPage = totalCount ? Math.ceil(totalCount / JOB_COUNT_PER_PAGE) : 0;

  const createPageHref = (page: number) => {
    return updateUrlWithParam(router.asPath, 'page', `${page}`);
  };

  return {
    maxPage,
    currentPage,
    createPageHref,
  };
};
